// extracted by mini-css-extract-plugin
module.exports = {"image":"news-module--image--1AiW0","h1":"news-module--h1--2MbnA","h2":"news-module--h2--2NMIG"};